module.exports = __webpack_public_path__ + "img/logo-tusdata.f17f5212.png";